/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalUserMediaCenterFileResponseV3Thumbnail interface.
 */
export function instanceOfInternalUserMediaCenterFileResponseV3Thumbnail(value) {
    return true;
}
export function InternalUserMediaCenterFileResponseV3ThumbnailFromJSON(json) {
    return InternalUserMediaCenterFileResponseV3ThumbnailFromJSONTyped(json, false);
}
export function InternalUserMediaCenterFileResponseV3ThumbnailFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mediumUrl': json['medium_url'] == null ? undefined : json['medium_url'],
        'previewUrl': json['preview_url'] == null ? undefined : json['preview_url'],
        'wideUrl': json['wide_url'] == null ? undefined : json['wide_url'],
    };
}
export function InternalUserMediaCenterFileResponseV3ThumbnailToJSON(json) {
    return InternalUserMediaCenterFileResponseV3ThumbnailToJSONTyped(json, false);
}
export function InternalUserMediaCenterFileResponseV3ThumbnailToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'medium_url': value['mediumUrl'],
        'preview_url': value['previewUrl'],
        'wide_url': value['wideUrl'],
    };
}
